<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <v-server-table style="min-height: 120px;" ref="ascReviewListGrid" id="opReviewListGrid" :columns="columns" :options="options" class="hiaTable"
      @loading="tableLoader = true" @loaded="tableLoader = false" v-loading="tableLoader" element-loading-spinner="atom-audit-loader">
      <!-- <template slot="selected" slot-scope="props">
        <input v-model="props.row.checked" @click="selectRecord(props.row, $event)" type="checkbox">
      </template> -->
      <template slot="projectName" slot-scope="props">
        <div>
          <router-link v-bind:to="`/projects/${props.row.projectId}`">{{props.row.projectName}}
          </router-link>
        </div>
      </template>
      <template slot="patientNumber" slot-scope="props">
        <div>
          <router-link v-bind:to="`/reviews/outpatient/${props.row.ascTableId}`">{{props.row.patientNumber}}
          </router-link>
        </div>
      </template>
      <template slot="dateOfService" slot-scope="props">
        <div>
          {{ props.row.dateOfService ? formatDate(props.row.dateOfService) : '' }}
        </div>
      </template>
      <template slot="completeDate" slot-scope="props">
        <div>
          {{ props.row.completeDate ? formatDate(props.row.completeDate) : '' }}
        </div>
      </template>
      <template slot="reviewDate" slot-scope="props">
        <div>
          {{ props.row.reviewDate ? formatDate(props.row.reviewDate) : '' }}
        </div>
      </template>

      <template slot="recordTags" slot-scope="props">
        <template v-if="props.row.recordTags">
          <div class="el-tag el-tag--mini el-tag--light" style="max-width: 100px; " v-for="tag in props.row.recordTags.split(',')" :key="tag">
            <div :title="tag" style="overflow: hidden; text-overflow: ellipsis;">
              {{ tag }}
            </div>
          </div>
        </template>
      </template>

    </v-server-table>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import dateHelper from '@/mixins/date-helper'
  import hiaTable from '@/mixins/hiaTable'

  export default {
    name: 'outpatientListFilter',
    mixins: [dateHelper, hiaTable],
    data() {
      return {
        localInpatientData: {},
        filterCriteria: '',
        tableLoader: false,
        loading: false,
        vueTables2Query: {},
        columns: ['projectName', 'patientNumber', 'patientType', 'mrNumber', 'consultantNumber', 'recordTags', 'payorName', 'coder', 'reasonForChange', 'dateOfService', 'comments', 'status', 'reviewDate'],
        options: {
          requestFunction: (data) => {
            return this.requestData(data)
          },
          debounce: 600,
          filterByColumn: true,
          listColumns: {
            reviewLevel: []
          },
          sortable: ['projectName', 'patientNumber', 'patientType', 'mrNumber', 'consultantNumber', 'recordTags', 'payorName', 'coder', 'reasonForChange', 'dateOfService', 'comments', 'status', 'reviewDate'],
          orderBy: {
            column: 'patientNumber',
            ascending: true
          },
          columnsClasses: {
            selected: 'selected',
            comments: 'customComments',
            delete: 'delete'
          },
          headings: {
            projectName: 'Project',
            patientNumber: 'Patient Number',
            consultantNumber: 'Consultant Number',
            recordTags: 'Record Tags',
            payorName: 'Payor',
            mrNumber: 'MR Number',
            coder: 'Coder',
            patientType: 'Pat Type',
            physicianName: 'Provider',
            dateOfService: 'Date of Service',
            reasonForChange: 'Reason F Change',
            comments: 'Comments',
            status: 'Review Status',
            reviewDate: 'Review Date',
            delete: ''
          },
          perPage: 15,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' }
          // columnsDropdown: true
        }
      }
    },
    methods: {
      ...mapActions('reports/', ['LOAD_ASCREPORTDATA_FILTERED']),
      ...mapMutations('reports/', ['SET_REPORTS_ASC_VUETABLEDATA', 'SET_REPORTS_TYPE']),
      async requestData(data) {
        try {
          this.SET_REPORTS_ASC_VUETABLEDATA(data)

          const payload = {
            outpatientReport: this.ambulatoryReport
          }

          this.statsLoading = true
          await Promise.all([this.LOAD_ASCREPORTDATA_FILTERED(payload)])
          this.statsLoading = false
          const opResults = {
            count: this.ambulatoryReport.outpatientData.paginatedCount,
            data: this.ambulatoryReport.outpatientData.outpatientListView
          }

          return opResults
        } catch (err) {
          console.log(err)
        }
      },
      refreshData() {
        this.$refs.reviewListGrid.getData()
      },
      showAddMoreColumns() {
        const popper = this.$refs.sortableColumns
        popper.referenceElm = this.$refs.sortableColumnsRef
        popper.doShow()
      }
    },
    watch: {},
    computed: {
      ...mapState('dropdowns/', ['dropdowns']),
      ...mapState('reports/', ['ambulatoryReport'])
    },
    created: function () {
      // this.localInpatientData = JSON.parse(JSON.stringify(this.reports.inpatientData))
    },
    components: {}
  }
</script>

<style scoped>
  >>>.VueTables__filters-row {
    display: none;
  }

  >>>.hiaTable>.table-responsive {
    overflow-x: auto;
  }
</style>